import { Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const TitleArea = styled.div`
  padding-bottom: 20px;
  color: ${colors.green};
  font-weight: bold;
  font-style: italic;
`

export const Container = styled.div`
  & > div:nth-of-type(even) {
    background: ${colors.grayExtraLight};
  }
`

export const ContainerItem = styled.div`
  display: flex;
  padding: 15px;

  height: 102px;

  align-items: center;
`

export const GridContainer = styled(Grid)`
  height: 61px;
`

export const ContainerAutocomplete = styled.div`
  /* & > div > div {
    margin: 10px 0px;
  } */
`

export const ContainerModal = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;
`
export const Icon = styled.img`
  width: 70px;
  height: 70px;
`

export const TextModal = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.blue};
  text-align: center;
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
`

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
`

export const IconDocumento = styled.img`
  src: ${props => props.src};
  width: 100px;
  height: 100px;
`

export const ContainerNoItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  & > h3 {
    padding-bottom: 16px;
  }
`
